<template lang="pug">
  .column.is-11
    b-modal(v-bind:active.sync="reminders.modalOpen" has-modal-card v-bind:width="640")
      reminder-modal(v-bind="reminders.modalProps" @submit="submitReminder")

    article.card.table-card
      header.card-header
        p.card-header-title Lembretes
        a.card-header-icon(@click="openModal")
          b-tooltip(label="Cadastrar Lembrete" type="is-dark" position="is-left")
            b-icon(icon="add_circle_outline")
      .card-content.is-paddingless
        b-table(
          v-bind:data="reminders.data",
          v-bind:striped="true",
          v-bind:narrowed="false",
          v-bind:mobile-cards="false",
          v-bind:loading="reminders.isLoading"
        )
          template(slot-scope="props")
            b-table-column(label="Item") {{props.row.name}}
            b-table-column(label="Tipo") {{props.row.type}}
            b-table-column(label="Valor Médio") {{props.row.value | currency}}
            b-table-column(label="Dia") {{props.row.day}}
            b-table-column(centered label="Gerenciar")
              b-tooltip(label="Editar Lembrete" type="is-dark")
                a(@click="openModal(props.row)")
                  b-icon(icon="edit" type="is-primary" size="is-small")
              b-tooltip(label="Excluir Lembrete" type="is-dark" style="margin-left: 20px")
                a(@click="confirmReminderDelete(props.row)")
                  b-icon(icon="delete" type="is-danger" size="is-small")
          template(slot="empty")
            section.section
              .content.has-text-grey.has-text-centered
                p
                  b-icon(icon="sentiment_very_dissatisfied", size="is-large")
                p Nenhum dado.
</template>

<script>
  import ReminderModal from './ReminderModal'

  import ReminderService from '@/services/reminder.js'

  export default {
    name: 'Reminders',
    components: {ReminderModal},
    data () {
      return {
        reminders: {isLoading: false, data: [], modalOpen: false, modalProps: {}}
      }
    },
    async created () {
      this.fetchReminders()
    },
    methods: {
      openModal (data) {
        this.reminders.modalProps = (data && data._id) ? {data} : {}
        this.reminders.modalOpen = true
      },
      async fetchReminders (params) {
        this.reminders.isLoading = true
        const response = await ReminderService.query(params)
        this.reminders.isLoading = false
        this.reminders.data = response.body.reminders
      },
      async submitReminder (data) {
        const isUpdate = (data._id)
        const {name, value, type, day} = data
        let payload = {name, value, type, day}

        const operation = (isUpdate) ? ReminderService.update(data._id, payload) : ReminderService.create(payload)

        const loadingComponent = this.$loading.open()
        try {
          await operation
          loadingComponent.close()
          let msg = (isUpdate) ? `atualizado` : `cadastrado`
          this.$snackbar.open({
            message: `Lembrete ${msg} com sucesso!`,
            position: 'is-top'
          })
          this.fetchReminders()
        } catch (e) {
          loadingComponent.close()
          let msg = (isUpdate) ? `atualizar` : `cadastrar`
          this.$snackbar.open({
            message: `Erro ao ${msg} o Lembrete!`,
            type: 'is-danger',
            actionText: 'Ver Erro',
            onAction: () => {
              this.$modal.open({content: `<pre>${JSON.stringify(e)}</pre>`})
            },
            position: 'is-top'
          })
        }
      },
      async confirmReminderDelete (reminder, index) {
        this.$internalDialog.confirm({
          title: 'Removendo Lembrete',
          message: 'Você tem certeza que deseja <b>remover</b> esse lembrete? Essa ação não pode ser desfeita.',
          cancelText: 'Cancelar',
          confirmText: 'Remover Lembrete',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: async () => {
            if (reminder._id) {
              const loadingComponent = this.$loading.open()
              try {
                await ReminderService.delete(reminder._id)
                loadingComponent.close()
                this.$toast.open('Lembrete removido!')
                this.fetchReminders()
              } catch (e) {
                loadingComponent.close()
                this.$snackbar.open({
                  message: 'Erro ao remover o Lembrete!',
                  type: 'is-danger',
                  actionText: 'Ver Erro',
                  onAction: () => {
                    this.$modal.open({content: `<pre>${JSON.stringify(e.body)}</pre>`})
                  },
                  position: 'is-top'
                })
              }
            } else {
              this.reminders.splice(index, 1)
              this.$toast.open('Arquivo removido!')
            }
          }
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  .table-card
    min-height: 15rem
</style>



// WEBPACK FOOTER //
// Reminders.vue?3e5a8b8e